/**
 * @author de-gha
 */
(function($) {
	var contextObj;
	var menu;
	var settings;
	
	$.extend($.fn, {
		
		DCMS_RCM: function(config){
			contextObj = this;
			
			settings = config;
			settings.fx = settings.fx || false;
			settings.fxType = settings.fxType || 'fade';
			settings.fxSpeed = settings.fxSpeed || 'fast';
			settings.onOpen = settings.onOpen || false;
			settings.onClose = settings.onClose || false;
			settings.noRCMClass = settings.noRCMClass || 'DCMS_disabledRCM';
			
			menu = $('#'+settings.menuId) || null;

			if (menu.length == 0)
			{
		  	return;
		  }
			menu.css('position: absolute');

		if (contextObj.is('a'))
			{
				$(this).filter(':not(.'+settings.noRCMClass+')').bind('contextmenu', function(e) {
					$(e.target).DCMS_showMenu(e);
					return false;
				});
			}
			else
			{
				$('a', this).filter(':not(.'+settings.noRCMClass+')').bind('contextmenu', function(e) {
					$(e.target).DCMS_showMenu(e);
					return false;
				});
			}
		},

		DCMS_showMenu: function(e)
		{
			if (typeof settings.onShow == 'function') settings.onShow(e, menu);
			if (settings.fx) 
			{
				switch (settings.fxType) {
					case 'fade':
						menu.css('top', e.pageY).css('left', e.pageX).fadeIn();
						break;
					case 'slide':
						menu.css('top', e.pageY).css('left', e.pageX).slideDown();
						break;
				}
			}
			else
			{
				menu.css('top', e.pageY).css('left', e.pageX).show();					
			}
			
			// Ein Klick in die Umgebung blendet Menue aus
			$(document).one('click', contextObj.DCMS_hideMenu);
			
		},

		DCMS_hideMenu: function()
		{
			//alert(outputObject(settings));
			if (typeof settings.onHide == 'function') settings.onHide();
			if (settings.fx) {
				switch (settings.fxType) {
					case 'fade':
						menu.fadeOut();
						break;
					case 'slide':
						menu.slideUp();
						break;
				}
			}
			else 
			{
				menu.hide();
			}
		}
	});
})(jQuery);